/**
 * track:log-jump — banner above the Log while the jump view is open, and the
 * notices for a jump that found nothing or failed.
 */
interface Props {
  seq: number;
  onBackToLive: () => void;
}

export function LogJumpBanner({ seq, onBackToLive }: Props) {
  return (
    <div
      data-testid="log-jump-banner"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        padding: "8px 12px",
        margin: "0 0 8px",
        fontSize: 12,
        color: "var(--text2)",
        background: "var(--surface2)",
        border: "1px solid var(--border)",
        borderRadius: 6,
      }}
    >
      <span>Showing #{seq} with the posts around it.</span>
      <button
        type="button"
        onClick={onBackToLive}
        style={{
          fontSize: 12,
          padding: "3px 10px",
          cursor: "pointer",
          color: "var(--accent)",
          background: "none",
          border: "1px solid var(--accent)",
          borderRadius: 4,
          fontFamily: "inherit",
        }}
      >
        Back to live
      </button>
    </div>
  );
}

export function logJumpMissingText(seq: number, first: number | null, last: number | null): string {
  return first !== null && last !== null
    ? `No post #${seq}. The Log runs from #${first} to #${last}.`
    : `No post #${seq}.`;
}

interface NoticeProps {
  text: string;
  onBackToLive?: () => void;
}

export function LogJumpNotice({ text, onBackToLive }: NoticeProps) {
  return (
    <div
      role="status"
      data-testid="log-jump-notice"
      style={{ fontSize: 12, color: "var(--text2)", padding: "8px 12px", margin: "0 0 8px", border: "1px solid var(--border)", borderRadius: 6 }}
    >
      {text}
      {onBackToLive && (
        <button
          type="button"
          onClick={onBackToLive}
          style={{ marginLeft: 10, fontSize: 12, cursor: "pointer", color: "var(--accent)", background: "none", border: "none", textDecoration: "underline", fontFamily: "inherit" }}
        >
          Dismiss
        </button>
      )}
    </div>
  );
}
